export default "__VITE_ASSET__d2777521__"